var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookOpenReader(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 219.125V431.662C0 445.912 11.625 457.912 26.5 458.662C75.318 461.18 180.178 471.367 240 512V245.232C181.361 205.492 79.898 194.85 29.75 192C13.5 191.125 0 203.5 0 219.125ZM482.25 192C432.16 194.848 330.875 205.467 272.203 245.094C272.074 245.182 272 245.326 272 245.482V511.906C332.043 471.518 436.695 461.178 485.5 458.662C500.375 457.912 512 445.912 512 431.662V219.125C512 203.5 498.5 191.125 482.25 192ZM352 96C352 43 309 0 256 0S160 43 160 96S203 192 256 192S352 149 352 96Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookOpenReader);
export default __webpack_public_path__ + "static/media/book-open-reader.cf65da507478e66b6e0978205d15947e.svg";
export { ForwardRef as ReactComponent };